import React, { FC } from "react";
import { Rotate } from "@baseTypes/baseType";
import { WorksDailyTooltip } from "../../tooltips/WorksDailyTooltip";
import FlexLine from "../../../../../../components/elements/flexLine/FlexLine";
import { WorksSeasonTooltip } from "../../tooltips/WorksSeasonTooltip";
import { IPeriod, WorkDisplayPeriod, WorkProgress } from "@baseTypes/service/dashboard/IWorksDashboardService";
import ProgressBar from "@elements/progressBar/ProgressBar";
import colors from "@infobis/ui-styles-utils/colors";
import { Status, WorkItemVariant } from "@pages/dashboard/works/components/WorkItem/WorkItem";
import WorkItemStatuses from "@pages/dashboard/works/components/WorkItem/WorkItemStatuses/WorkItemStatuses";

type WorkItemBarsProps = {
    listWrapperRef?: React.RefObject<HTMLDivElement | null>
    averageSeason: number
    averageToday: number
    today: WorkProgress
    season: WorkProgress
    period?: IPeriod
    onClick?: (period: WorkDisplayPeriod) => void
    width?: number
    statuses?: Status[]
    statusesLoading?: boolean
    variant: WorkItemVariant
}

const WorkItemBars: FC<WorkItemBarsProps> = (props) => {
    const {
        listWrapperRef,
        averageSeason,
        averageToday,
        season,
        today,
        period,
        onClick,
        width = 500,
        statuses,
        statusesLoading = false,
        variant
    } = props;

    return (
        <FlexLine rotate={Rotate.Column} style={{ flex: `0 0 ${width}px`, maxWidth: width, gap: 4 }}>
            <WorksDailyTooltip cropPeriods={today.cropPeriods} container={listWrapperRef}>
                <ProgressBar
                    percent={averageToday}
                    fillColor={colors.ELEMENTS_CHARTS_16}
                    bgColor={'rgba(255, 227, 125, 0.50)'}
                    height={24}
                    borderRadius={5}
                    onClick={onClick ? () => onClick('today') : undefined}
                />
            </WorksDailyTooltip>
            <WorksSeasonTooltip
                header={period && { from: period.from, to: period.to }}
                cropPeriods={season.cropPeriods}
                container={listWrapperRef}
            >
                <ProgressBar
                    percent={averageSeason}
                    fillColor={colors.ELEMENTS_CHARTS_2}
                    bgColor={'rgba(158, 115, 248, 0.30)'}
                    height={variant === 'default' ? 8 : 12}
                    borderRadius={variant === 'default' ? 2 : 4}
                    onClick={onClick ? () => onClick('full') : undefined}
                />
            </WorksSeasonTooltip>
            { statuses && <WorkItemStatuses statuses={statuses} statusesLoading={statusesLoading} /> }
        </FlexLine>
    )
}

export default WorkItemBars;